/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Filter_ClearInputs */

const cs_users_filter_clear = /** @type {(inputs: Users_Filter_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zrušit filtr`)
};

const en_users_filter_clear = /** @type {(inputs: Users_Filter_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear filter`)
};

/**
* | output |
* | --- |
* | "Clear filter" |
*
* @param {Users_Filter_ClearInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const users_filter_clear = /** @type {((inputs?: Users_Filter_ClearInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Filter_ClearInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_filter_clear(inputs)
	return cs_users_filter_clear(inputs)
});